export const rating = (stars: string) =>
  "★★★★★☆☆☆☆☆".slice(5 - Number(stars), 10 - Number(stars));
